import {
  fetchGetExchangeableQuantityDocument,
  fetchGetPointsProductsDocument,
  fetchPointsConfigDocument,
  fetchPointsHistoryDocument,
} from '../graphql/docs/integral';
import { fetcher } from '../graphql/fetcher';

/**
 * 获取积分商品列表
 * @param variables
 * @returns
 */
export const fetchGetPointsProducts = async (variables: {
  isAllowExchange: boolean;
  options: AnyObject;
}) => {
  const res = await fetcher.query(fetchGetPointsProductsDocument, {
    variables,
  });
  return res.data.value?.getPointsProducts;
};

/**
 * 获取积分明细
 * @param options
 * @returns
 */
export const fetchPointsHistory = async (options: AnyObject) => {
  const res = await fetcher.query(fetchPointsHistoryDocument, {
    variables: {
      options,
    },
  });
  return res.data.value?.pointsHistory;
};

/** 获取积分规则 */
export const fetchPointsConfig = async () => {
  const res = await fetcher.query(fetchPointsConfigDocument, {
    variables: {},
  });
  return res.data.value?.pointsConfig;
};

/**
 * 获取积分商品已兑换数量
 * @param productId
 * @param type
 * @param isIncludeCurrentOrder
 * @returns
 */
export const fetchGetExchangeableQuantity = async (
  productId: string,
  type: string,
  isIncludeCurrentOrder: boolean
) => {
  const res = await fetcher.query(fetchGetExchangeableQuantityDocument, {
    variables: {
      productId,
      type,
      isIncludeCurrentOrder,
    },
  });
  return res.data.value?.getExchangeableQuantity;
};
